import { render, staticRenderFns } from "./managequality.vue?vue&type=template&id=666e1c49&scoped=true&"
import script from "./managequality.vue?vue&type=script&lang=js&"
export * from "./managequality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e1c49",
  null
  
)

export default component.exports